import { useMutation, useQueryClient } from '@tanstack/react-query'
import { BrokeFlexMessageService } from '../services/BrokeFlexMessageService'
import { MessagingQueryKey } from '../../keys'

interface UseMutationDeleteBrokeFlexMessageCampaignOptions {
	onSuccess?: () => void
	onError?: (error: Error) => void
}

export default function useMutationDeleteBrokeFlexMessageCampaign({
	onSuccess,
	onError,
}: UseMutationDeleteBrokeFlexMessageCampaignOptions = {}) {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: (id: string) => BrokeFlexMessageService.deleteCampaign(id),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: [MessagingQueryKey.GetBrokeFlexMessageCampaigns],
			})
			onSuccess?.()
		},
		onError,
	})
}
